import { ReactElement } from 'react';
import { localizedStrings } from '../../../localizedStrings';
export const FourOhFour = (): ReactElement => {
  return <h1>{localizedStrings.error[404]}</h1>;
};
